module.exports = __webpack_public_path__ + "static/img/bg.24dade2f.jpg";